
import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"
import { Typography, Box } from "@mui/material"

export default function useTableColumnAgendaVisita() {
  const columnsPautas = useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: 'nombre',
        header: 'Pauta',
        size: 120,
        enableColumnActions: false,
        enableSorting: false,
        Cell: ({ cell }) => (
          <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'descripcion',
        header: 'Descripción',
        enableSorting: false,
        enableColumnActions: false,
        Cell: ({ cell }) => (
          <Box sx={{ whiteSpace: 'normal' }}>
            <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>
              {cell.getValue<string>()}
            </Typography>
          </Box>
        ),
      }

    ], []
  )
  return {
    columnsPautas
  }
}